import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="24" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 0.89543 0.895431 0 2 0H7C8.10457 0 9 0.895431 9 2V7C9 8.10457 8.10457 9 7 9H2C0.89543 9 0 8.10457 0 7V2ZM2 2H7V7H2L2 2Z"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 10.8954 0.895431 10 2 10H7C8.10457 10 9 10.8954 9 12V17C9 18.1046 8.10457 19 7 19H2C0.89543 19 0 18.1046 0 17V12ZM2 12H7V17H2L2 12Z"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C10.8954 0 10 0.89543 10 2V7C10 8.10457 10.8954 9 12 9H17C18.1046 9 19 8.10457 19 7V2C19 0.895431 18.1046 0 17 0H12ZM17 2H12V7H17V2Z"
        className="fill"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 12C10 10.8954 10.8954 10 12 10H17C18.1046 10 19 10.8954 19 12V17C19 18.1046 18.1046 19 17 19H12C10.8954 19 10 18.1046 10 17V12ZM12 12H17V17H12V12Z"
        className="fill"
      />
    </svg>
  );
};

export default Svg;
